import { render, staticRenderFns } from "./I18NImage.vue?vue&type=template&id=72f26506&"
import script from "./I18NImage.vue?vue&type=script&lang=js&"
export * from "./I18NImage.vue?vue&type=script&lang=js&"
import style0 from "./I18NImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports